import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_CUSTOM_BENCHMARK_PATH,
  GetCustomBenchmarksErrorDto,
  GetCustomBenchmarksRequestPathVariables,
  GetCustomBenchmarksRequestQueryParams,
  GetCustomBenchmarksSuccessDto,
} from '@/api/rest/resources/types/benchmark';
import { assertIsDefined } from '@/utils/assert';

export const customBenchmarkKeys = {
  all: (orgId: string) => ['organization', orgId, 'custom-benchmarks'] as const,
  lists: (orgId: string, indicator?: string) => [...customBenchmarkKeys.all(orgId), 'list', indicator || 'all'],
};

export const useGetCustomBenchmarks = (organizationId: string, indicatorName?: string) => {
  assertIsDefined(organizationId, 'organizationId');

  const pathVariables: GetCustomBenchmarksRequestPathVariables = {
    organization_id: organizationId,
  };
  const queryParams: GetCustomBenchmarksRequestQueryParams = indicatorName ? { indicator_name: indicatorName } : {};

  const queryKey = customBenchmarkKeys.lists(organizationId, indicatorName);

  const queryFn = async () => {
    return getRequest<
      GetCustomBenchmarksSuccessDto,
      GetCustomBenchmarksRequestPathVariables,
      GetCustomBenchmarksRequestQueryParams
    >(GET_CUSTOM_BENCHMARK_PATH, pathVariables, queryParams);
  };

  return useSuspenseQuery<GetCustomBenchmarksSuccessDto, GetCustomBenchmarksErrorDto>({
    queryKey,
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
